import { makeStyles } from "@mui/styles";
import React from "react";
import Menu from "./Menu";
import Router from "./Router";
import EventStreamer from "../../data/Streaming/EventStreamer";

const useStyles = makeStyles(() => ({
    content: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        borderTop: "1px solid #AAA",
        maxHeight: "calc(100vh - 60px)"
    }
}));

const Layout: React.FC = () => {
    const classes = useStyles();

    return (
        <>

            <Menu />

            <div className={classes.content}>

                <Router />

            </div>

            <EventStreamer />

        </>
    );
};

export default Layout;
